if (!customElements.get("cart-add")) {
  class CartAdd extends HTMLElement {
    constructor() {
      super();
    }

    update(element) {
      this.innerHTML =
        element.dataset.available == "true"
          ? this.dataset.add
          : this.dataset.unavailable;
      this.toggleAttribute("disabled", element.dataset.available == "false");
    }

    connectedCallback() {
      this.classList.remove("disabled");

      this.addEventListener("click", (event) => {
        event.stopPropagation();

        if (this.hasAttribute("disabled")) return;

        let variantId = this.dataset.variantId;
        const select =
          this.closest(".js-product-card").querySelector(".is-active");
        if (select) variantId = select.dataset.variantId;

        addToCart(variantId, 1);
      });
    }
  }
  customElements.define("cart-add", CartAdd);
}
